;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"F1ESxZhEUN1x7xA2YoRX3"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';
import type { ErrorEvent } from '@sentry/nextjs';
import type { TransactionEvent } from '@sentry/core';
import getConfig from 'next/config';

import { hasSentryConsent } from './helpers/sentryConsent';

// Drop events until Didomi consent is granted (see helpers/sentryConsent.ts).
const beforeSend = (event: ErrorEvent): ErrorEvent | null =>
  hasSentryConsent() ? event : null;

const beforeSendTransaction = (
  event: TransactionEvent,
): TransactionEvent | null => (hasSentryConsent() ? event : null);

const initSentry = () => {
  const { publicRuntimeConfig } = getConfig();
  const { SENTRY_DSN, FEATURE_SENTRY, ENVIRONMENT_NAME } =
    publicRuntimeConfig ?? {};

  if (!FEATURE_SENTRY || !SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT_NAME,
    // Send envelopes through our own origin so ad/tracker blockers don't drop them.
    // /api/event (pages/api/event.ts) strips cookies before forwarding to Sentry —
    // donedeal's large cookies are otherwise rejected by Sentry's ingest with an nginx
    // "header too large" 400. Deliberately neutral name so it doesn't look like tracking.
    tunnel: '/api/event',
    tracesSampleRate: 0.02,
    integrations: [Sentry.browserTracingIntegration()],
    // Don't attach cookies/headers/IP/user data (this is the SDK default; set explicitly to be clear).
    sendDefaultPii: false,
    // The replay integration is NOT added here — it's added on consent in hooks/UseSentry.ts
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend,
    beforeSendTransaction,
  });
};

initSentry();
